import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: "index",
    component: () => import('@/views/index'),
    meta: {
      title: "成都吉瓦特科技有限公司",
    },
  },
  {
    path: '/aboutUs',
    name: "aboutUs",
    component: () => import('@/views/aboutUs/aboutUs'),
    meta: {
      title: "关于我们_成都吉瓦特科技有限公司",
    },
  },
  {
    path: '/product',
    name: "product",
    component: () => import('@/views/product/product'),
    meta: {
      title: "产品_成都吉瓦特科技有限公司",
    },
  },
  {
    path: '/productdetails',
    name: "productdetails",
    component: () => import('@/views/productdetails/productdetails'),
    meta: {
      title: "产品详情_成都吉瓦特科技有限公司",
    },
  },
  {
    path: '/journalism',
    name: "journalism",
    component: () => import('@/views/journalism/journalism'),
    meta: {
      title: "新闻_成都吉瓦特科技有限公司",
    },
  },
  {
    path: '/particulars',
    name: "particulars",
    component: () => import('@/views/particulars/particulars'),
    meta: {
      title: "新闻详情_成都吉瓦特科技有限公司",
    },
  },
  {
    path: '/supportCenter',
    name: "supportCenter",
    component: () => import('@/views/supportCenter/supportCenter'),
    meta: {
      title: "支持中心_成都吉瓦特科技有限公司",
    },
  },
  {
    path: '/contactus',
    name: "contactus",
    component: () => import('@/views/contactus/contactus'),
    meta: {
      title: "联系我们_成都吉瓦特科技有限公司",
    },
  },
  {
    path: "*",
    name: "",
    component: () => import('@/views/error/404'),
    meta: {
      title: "页面不存在",
    },
  },

]

const router = new VueRouter({
  mode: 'history', //hash history
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终返回{ x: 0, y: 0 }，页面就会滚动到顶部
    return { x: 0, y: 0 };
  }
})


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  // console.log(to);
  document.title = to.meta.title; //动态改变浏览器标题
  next()
  // if (to.path === "/login") {
  //   //当进入的就是登陆页面或者注册页面时，不做操作
  //   next();
  // } else {
  //   if (localStorage.getItem('token')) {
  //     //同过登陆成功时存储在本地用户名，来判断用户是否成功登陆
  //     next();
  //   } else {
  //     next("/login");
  //   }
  // }
});

export default router
